import * as _ from 'lodash';

angular.module("tromanWeb").factory('filterBuilder', ['ergoDateFilter', function (ergoDateFilter) {
    function formatCandidate(candidate) {
        if (_.isDate(candidate)) {
            return ergoDateFilter(candidate);
        }
        return ('' + candidate).toLowerCase();
    }

    return function filterBuilder(getCandidates) {
        return function (array, predicate) {
            if (predicate == null) return array;
            if (!_.isString(predicate.$)) return array;
            if (!_.isArray(array)) return array;

            var expected = predicate.$.toLowerCase()
                .split(' ')
                .map(x => x.trim())
                .filter(x => x.length > 0);
            
            return array.filter(function (item) {
                if (item == null) return false;

                let candidates = getCandidates(item).filter(x => x != null).map(formatCandidate);

                return expected.every(part => candidates.some(x => x.indexOf(part) >= 0));
            });
        };
    };
}]);

angular.module("tromanWeb").filter('filterDivisions', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(division => [
        division.Name,
        division.Abbreviation,
    ]);
}]);

angular.module("tromanWeb").filter('filterMeetings', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(meeting => [
        meeting.Organization && meeting.Organization.Name,
        meeting.Location,
        meeting.Designation,
    ]);
}]);

angular.module("tromanWeb").filter('filterMeetingPolitikerInfo', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(meetingPolitikerInfo => [
        meetingPolitikerInfo.Meeting.Organization && meetingPolitikerInfo.Meeting.Organization.Name,
        meetingPolitikerInfo.Meeting.Location,
        meetingPolitikerInfo.Meeting.Designation,
    ]);
}]);

angular.module("tromanWeb").filter('filterMeetingPendingInfo', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(meetingPendingInfo => [
        meetingPendingInfo.Meeting.Organization && meetingPendingInfo.Meeting.Organization.Name,
        meetingPendingInfo.Meeting.Designation,
    ]);
}]);

angular.module("tromanWeb").filter('filterCeremonies', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(ceremony => [
        ceremony.Mission.Person.name,
        ceremony.Mission.MandatePeriod.Organization.Name,
        ceremony.Location,
        ceremony.Designation,
    ]);
}]);

angular.module("tromanWeb").filter('filterMissions', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(mission => [
        mission.Start,
        mission.End,
        mission.Person ? mission.Person.display : 'vakant',
        mission.MissionType && mission.MissionType.Name,
        mission.Party && mission.Party.Abbreviation && '(' + mission.Party.Abbreviation + ')',
        mission.MandatePeriod && mission.MandatePeriod.Organization && mission.MandatePeriod.Organization.Name,
    ]);
}]);

angular.module("tromanWeb").filter('filterMissionTypes', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(missionType => [
        missionType.Name,
        missionType.Abbreviation,
    ]);
}]);

angular.module("tromanWeb").filter('filterOrganizations', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(org => [
        org.Name,
        org.Abbreviation,
        org.OrganizationType && org.OrganizationType.Name,
    ]);
}]);

angular.module("tromanWeb").filter('filterOrganizationTypes', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(organizationType => [
        organizationType.Name,
        organizationType.Description,
    ]);
}]);

angular.module("tromanWeb").filter('filterParties', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(party => [
        party.Name,
        party.Abbreviation,
    ]);
}]);

angular.module("tromanWeb").filter('filterWageTypes', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(wageType => [
        wageType.Code,
        wageType.Name,
        wageType.Information,
    ]);
}]);

angular.module("tromanWeb").filter('filterWageCalculations', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(calculation => [
        calculation.Name,
        calculation.WageTypes.Ordinary[0].WageType && calculation.WageTypes.Ordinary[0].WageType.Code,
        calculation.WageTypes.Substitute[0].WageType && calculation.WageTypes.Substitute[0].WageType.Code,
        calculation.WageTypes.Serving[0].WageType && calculation.WageTypes.Serving[0].WageType.Code,
        calculation.WageTypes.Travel.WageType && calculation.WageTypes.Travel.WageType.Code,
    ]);
}]);

angular.module("tromanWeb").filter('filterPersons', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(person => [
        person.firstName,
        person.LastName,
        person.PersonalNumber,
        person.Party && person.Party.Abbreviation && ('(' + person.Party.Abbreviation + ')'),
        person.emailPublic && person.emailPublic.Email,
    ]);
}]);

angular.module("tromanWeb").filter('filterWageGroups', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(wageGroup => [
        wageGroup.Name,
        wageGroup.Description,
    ]);
}]);

angular.module("tromanWeb").filter('filterMissionGroups', ['filterBuilder', function (filterBuilder) {
    return filterBuilder(missionGroup => [
        missionGroup.Name,
    ]);
}]);

angular.module("tromanWeb").filter('filterPendingCertification', ['filterBuilder', function (filterBuilder) {
    let genericFilter = filterBuilder(pending => [
        pending.Organization.Name,
        pending.Certifier?.name,
    ]);
    return function(array, predicate) {
        if (predicate?.$hasPending) {
            array = _.filter(array, x => x.Count > 0);
        }
        return genericFilter(array, predicate);
    };
}]);